<template>
  <div class="my-export-excel">
    <el-button
      :loading="btnLoading"
      :disabled="btnLoading"
      type="warning"
      icon="el-icon-paperclip"
      @click="exportClick()"
      :size="size"
      >导出</el-button
    >
    <el-dialog
      :visible.sync="dialogState.show1"
      :close-on-click-modal="false"
      :title="'导出'"
      append-to-body
      @close="dialogClose"
      width="861px"
    >
      <div style="width: 92%; margin-left: 8%">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <div style="margin: 15px 0"></div>
        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
          <el-checkbox
            class="el-checkbox-width"
            v-for="(item, index) in titleList"
            :label="item"
            :key="index"
            >{{ item.keyNameCn }}</el-checkbox
          >
        </el-checkbox-group>
        <!-- <div>
          导出数量
          <el-input
            v-model="exportNum"
            style="width: 75%; margin-top: 20px"
            size="small"
            type="number"
          ></el-input>
        </div> -->
      </div>

      <div style="margin: 20px; text-align: center">
        <el-button type="primary" @click="dialogOk">导出</el-button>
        <el-button @click="dialogClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ajax from "@/core/http/index.js";
import { forEach } from "min-dash";
export default {
  props: {
    // 导出数据的ID集合
    idsList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // 模糊查询参数
    size: {
      type: String,
      default: "small",
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
    // 导出地址
    url: {
      type: String,
      default: "",
    },
    // 导出后excel名称
    excelName: {
      type: String,
      default: "excel",
    },
    // 导出的参数
    excelTitleList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      btnLoading: false,
      dialogState: {
        show1: false,
      },
      //   导出需要的列表参数
      titleList: [],
      //
      checkAll: false,
      checkedCities: [],
      isIndeterminate: true,
      //   导出数量
      exportNum: 100,
    };
  },
  methods: {
    // 多选
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.titleList : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.titleList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.titleList.length;
    },
    // 导出
    exportClick() {
      this.titleList = [];
      this.excelTitleList.forEach(async (item) => {
        if (item.isShow === true) {
          let mainList = [
            101,
            103,
            105,
            121,
            123,
            125,
            131,
            132,
            133,
            141,
            151,
            134,
            139,
          ];
          let detailsList = [102, 104, 122, 124, 142, 152];
          let productList = [1];
          let customerList = [6];
          let supplierList = [11];
          let value = item.value;
          await mainList.forEach((element) => {
            let name = element + "-ext";
            if (item.value.indexOf(name) > -1) {
              value = item.value.replace(element + "-", "main_");
            }
          });
          await detailsList.forEach((element) => {
            let name = element + "-ext";
            if (item.value.indexOf(name) > -1) {
              value = item.value.replace(element + "-", "details_");
            }
          });
          await productList.forEach((element) => {
            let name = element + "-ext";
            if (item.value.indexOf(name) > -1) {
              value = item.value.replace(element + "-", "prouct_");
            }
          });
          await customerList.forEach((element) => {
            let name = element + "-ext";
            if (item.value.indexOf(name) > -1) {
              value = item.value.replace(element + "-", "customer_");
            }
          });
          await supplierList.forEach((element) => {
            let name = element + "-ext";
            if (item.value.indexOf(name) > -1) {
              value = item.value.replace(element + "-", "supplier_");
            }
          });
          let json = {
            keyNameCn: item.name,
            keyValueEn: value,
          };
          this.titleList.push(json);
        }
      });
      this.checkedCities = this.titleList;
      this.isIndeterminate = true;
      this.btnLoading = true;
      this.dialogState.show1 = true;
    },
    defaultBtnLoading() {
      this.btnLoading = false;
    },
    dialogClose() {
      this.dialogState.show1 = false;
      this.btnLoading = false;
    },
    dialogOk() {
      this.$message.success("创建导出文件中......");
      this.dialogClose();
      // 处理值isshow为true的
      let json = {
        exportFieldMapDtoList: this.checkedCities,
        filter: this.filter,
        ids: this.idsList,
        // pageParam: { pageNum: 0, pageSize: this.exportNum },
      };
      ajax
        .fetchDownload(this.url, json, this.excelName + ".xlsx")
        .then((res) => {
          this.$message.success("导出成功！");
          this.btnLoading = false;
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.my-export-excel {
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
}
.el-checkbox-width {
  width: 20%;
}
</style>
